import { Controller } from "@hotwired/stimulus";

export default class ToggleableController extends Controller {
  static values = {
    antiAttrs: Array,
    state: {
      default: false,
      type: Boolean,
    },
    syncedAttrs: Array,
  };

  declare antiAttrsValue: string[];
  declare readonly hasAntiAttrsValue: boolean;
  declare readonly hasSyncedAttrsValue: boolean;
  declare stateValue: boolean;
  declare syncedAttrsValue: string[];

  private setAttrs(attrs: string[], matchState: boolean = true): void {
    const attrState = String(matchState ? this.stateValue : !this.stateValue);

    attrs.forEach((attr) => {
      this.element.setAttribute(attr, attrState);
    });
  }

  toggle(): void {
    this.stateValue = !this.stateValue;

    if (this.hasSyncedAttrsValue) {
      this.setAttrs(this.syncedAttrsValue);
    }

    if (this.hasAntiAttrsValue) {
      this.setAttrs(this.antiAttrsValue, false);
    }

    this.dispatch(this.stateValue ? "open" : "closed", {
      bubbles: true,
      target: this.element,
    });
  }
}
